var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("popup", {
    attrs: { opened: _vm.popupOpened, "use-footer": true },
    on: {
      "update:opened": function($event) {
        _vm.popupOpened = $event
      },
      confirm: _vm.confirm,
      cancel: function() {
        _vm.$emit("update:opened", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return undefined
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }